import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import Select from 'react-select';
import { RiRefreshLine } from "react-icons/ri";
import { ClipLoader } from "react-spinners";
import { FaSave, FaChevronLeft, FaEdit, FaTrash } from "react-icons/fa";
import { IoSearchOutline } from "react-icons/io5";
import { Modal, Button, Form } from "react-bootstrap";
import LeaseApiService from '../../services/apiService';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import WindowedSelect from 'react-windowed-select';
import moment from 'moment';
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';
const REACT_APP_REPORTS = process.env.REACT_APP_REPORTS_URL

const BulkReceipt = () => {
    const [precision, setPrecision] = useState();
    const [FilterTab, setFilterTab] = useState(true);
    const [loading, setloader] = useState(false);
    const { currencyPrecision } = useCurrency();

    const [activeTab, setActiveTab] = useState(0);
    const [leaseTerm, setLeaseTerm] = useState([]);
    const [PaymentTab, setPaymentTab] = useState(true);
    const [gridVisibility, setGridVisibility] = useState([true, false, false]);
    const [totalRent, setTotalRent] = useState();
    const [totalVat, setTotalVat] = useState();
    const [totalAmount, setTotalAmount] = useState();
    const [totalTax, setTotalTax] = useState();
    const [show, setShow] = useState(false);
    const [editIndex, setEditIndex] = useState(null);
    const handleClose = () => setShow(false);
    const apiService = new LeaseApiService();
    const navigate = useNavigate();

    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
        const newGridVisibility = gridVisibility.map(
            (_, index) => index === tabIndex
        );
        setGridVisibility(newGridVisibility);
    }
    const handleBackClick = () => {
        window.history.back();
    }
    // Tenant
    const [unitList, setUnitList] = useState([])
    const [proprtyList, setProperty] = useState([]);
    const [tenantList, setTanentList] = useState([]);
    const [transList, setTransList] = useState([]);
    const [receiveables, setReceiveables] = useState([]);
    const [paymentMethod, setPaymentMethod] = useState([]);
    const [drawnBankList, setdrawnBankList] = useState([]);
    const [ModelDebitAccounts, setModelDebitAccounts] = useState([]);
    const [ModelTaxMaster, setModelTaxMaster] = useState([]);
    const [unitData, setUnitData] = useState();
    const [selectedTrans, setSelectedTrans] = useState(null);

    useEffect(() => {
        fetchDropdownData();
    }, []);

    const defaultFormData = {
        DueDate: "",
        IntAmount: "",
        TaxCode: "",
        VAT: "",
        Total: "",
        PaymentMethod: [{ label: 'PDC', value: 'PDC' }],
        ChequeNo: "",
        chequeDate: "",
        drawnBank: "",
        DabitAC: "",
        DabitAcName: "",
        Narration: "",
    };
    const [formData, setFormData] = useState(defaultFormData);
    const receptType = [
        { value: 'Lease Receipt', label: 'Lease Receipt' },
    ]
    const [receiptData, setReceiptData] = useState({
        receiptType: [{ label: 'Lease Receipt', value: 'Lease Receipt' }],
        refNo: '',
        payee: '',
        narration: '',
        description: '',
        installment: '',
    })
    const [transData, setTransData] = useState({
        Proprty: [{ label: 'Select Property', value: '' }],
        unitNo: [{ label: 'Select Unit No', value: '' }],
        Tenant: [{ label: 'Select Tenant', value: '' }],
        TenantNo: [{ label: 'Select Tenant No', value: '' }],
    })
    const columnDefs = [
        { checkboxSelection: true, headerCheckboxSelectionFilteredOnly: true, suppressMovable: true, width: 50, pinned: 'left' },
        { headerName: 'Lease No', field: 'LeaseNo', filter: true, floatingfilter: true, suppressMovable: true, width: 200, pinned: 'left' },
        { headerName: 'Property', field: 'Property_Name', filter: true, floatingfilter: true, suppressMovable: true, width: 280 },
        { headerName: 'Unit No', field: 'Unit_No', filter: true, floatingfilter: true, suppressMovable: true, width: 200 },
        { headerName: 'Rent', field: 'Rent', filter: true, floatingfilter: true, suppressMovable: true, width: 150 },
        { headerName: 'Tenant No', field: 'TenantNo', filter: true, floatingfilter: true, suppressMovable: true, width: 200 },
        { headerName: 'Tenant', field: 'TenantName', filter: true, floatingfilter: true, suppressMovable: true, width: 250 },
        { headerName: 'Contact No', field: 'ContactNo', filter: true, floatingfilter: true, suppressMovable: true, width: 200 },
    ]
    const fetchDropdownData = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'CreateBulkReceiptPropertyNos,CreateBulkReceiptTenants,ModelPaymentMethods,ModelDebitAccounts,ModelDrawnBankNames,ModelTaxMaster');
            const res = await apiService.getApiParamater('MULTIDROP_BULK_RECEIPT', `?${params.toString()}`);
            setProperty(res?.data?.dropdowns?.PropertyNo)
            setTanentList(res?.data?.dropdowns?.CreateBulkReceiptTenants)
            setPaymentMethod(res?.data?.dropdowns?.ModelPaymentMethods)
            setdrawnBankList(res?.data?.dropdowns?.ModelDrawnBankNames)
            setModelDebitAccounts(res?.data?.dropdowns?.ModelDebitAccounts)

            const duductoinParam = new URLSearchParams();
            duductoinParam.append('Action', 'GetTaxDetails');
            const deductionRes = await apiService.getApiParamater('TERMINATION_COMMON', `?${duductoinParam.toString()}`);
            setModelTaxMaster(deductionRes?.data?.result?.data)

        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }
    const handlePropertyChange = async (selectedOption) => {
        const params = new URLSearchParams();
        params.append('DropdownFor', 'LBRCreateUnitNosByPropertyId');
        params.append('CascadValue', selectedOption?.value);
        const res = await apiService.getApiParamater('CASCAD_BULK_RECEIPT', `?${params.toString()}`);
        setUnitList(res?.data?.items);
        setTransData({
            ...transData,
            Proprty: selectedOption,
            unitNo: [{ label: '', value: '' }]
        });
    }
    const handleUitNo = (selectedOption) => {
        setTransData({ ...transData, unitNo: selectedOption });
    }
    const handleTenant = (selectedOption) => {
        const selectedTanent = tenantList?.find(pro => pro?.text === selectedOption?.label)
        setTransData({
            ...transData,
            Tenant: selectedOption,
            TenantNo: { label: selectedTanent?.value || "", value: selectedTanent?.text || "" },
        });
    }
    const handleTenantNo = (selectedOption) => {
        const selectedTanent = tenantList?.find(pro => pro?.value === selectedOption?.label)
        setTransData({
            ...transData,
            TenantNo: selectedOption,
            Tenant: { label: selectedTanent?.text || "", value: selectedTanent?.value || "" },
        });
    }
    const handleTransSearch = async () => {
        const params = new URLSearchParams();
        params.append('Action', 'GetCreateSerchLeaseList');
        params.append('TenantName', transData?.Tenant?.label || "All");
        params.append('TenantNo', transData?.TenantNo?.label || "All");
        params.append('PropertyNo', transData?.Proprty?.value || "All");
        params.append('UnitNo', transData?.unitNo?.label || "All");
        params.append('PropertyName', transData?.Proprty?.label || "All");
        const res = await apiService.getApiParamater('COMMON_BULK_RECEIPT', `?${params.toString()}`);
        let data = res?.data?.result?.data
        if (data?.length > 0) {
            setTransList(data || []);
        } else {
            setTransList([data] || []);
        }
    }
    const handleClearFilters = () => {
        setTransData({
            Proprty: [{ label: 'Select Property', value: '' }],
            unitNo: [{ label: 'Select Unit No', value: '' }],
            Tenant: [{ label: 'Select Tenant', value: '' }],
            TenantNo: [{ label: 'Select Tenant No', value: '' }],
        });
        setTransList([])
        setSelectedTrans()
        setUnitList([])
    }
    // Unit Details
    const [dataList, setDataList] = useState([]);
    const receVAT = receiveables?.reduce((sum, row) => sum + (parseFloat(row?.VAT) || 0), 0);
    const recAmount = receiveables?.reduce((sum, row) => sum + (parseFloat(row?.Amount) || 0), 0);
    const recIntAmount = receiveables?.reduce((sum, row) => sum + (parseFloat(row?.IntAmount) || 0), 0);
    const recPaidAmount = receiveables?.reduce((sum, row) => sum + (parseFloat(row?.AmountPaid) || 0), 0);
    const recBalance = receiveables?.reduce((sum, row) => sum + (parseFloat(row?.Balance) || 0), 0);
    const recTotal = receiveables?.reduce((sum, row) => sum + (parseFloat(row?.Total) || 0), 0);
    const [receiptDate, setReceiptDate] = useState("");
    const [selectedIndex, setSelectedIndex] = useState(null); // Track selected row index



    useEffect(() => {
        const today = new Date();
        const formattedToday = today.toISOString().split("T")[0];
        setReceiptDate(formattedToday);
    }, []);

    const handleShow = (index) => {
        const selectedData = receiveables[index];

        // find vat record from texlist that matches TaxCode
        const matchedVat = ModelTaxMaster.find(t => t.RecordId === selectedData.TaxCode);
        
        setEditIndex(index);
        setFormData({
            ...defaultFormData,
            ...selectedData,
            Amount: selectedData?.Balance,
            VatCode: matchedVat ? {
                value: matchedVat.RecordId,   // just ID for value
                label: matchedVat.Description,
                rate: matchedVat.Rate,
                VatAcCode: matchedVat.VatAcCode
            } : null
        });
        
        setShow(true);
    };
    const onRowSelect = async (selectedRow, index) => {
        setSelectedTrans(selectedRow);
        setSelectedIndex(index);

        const params = new URLSearchParams();
        params.append('Action', 'GetCreateLeaseDeatils');
        params.append('LeaseNo', selectedRow?.LeaseNo);

        const res = await apiService.getApiParamater('COMMON_BULK_RECEIPT', `?${params.toString()}`);
        let term = res?.data?.result?.data;

        if (term[0]?.LeaseNo) {
            setDataList(res?.data?.result?.data);

            const totalRent = term.reduce((sum, row) => sum + (parseFloat(row?.Rent) || 0), 0);
            const totalVat = term.reduce((sum, row) => sum + (parseFloat(row?.VAT) || 0), 0);
            const totalAmount = term.reduce((sum, row) => sum + (parseFloat(row?.Total) || 0), 0);

            setTotalAmount(totalAmount);
            setTotalVat(totalVat);
            setTotalRent(totalRent);

            const sndparams = new URLSearchParams();
            sndparams.append('Action', 'GetCreateLeaseTenantDetails');
            sndparams.append('LeaseNo', selectedRow?.LeaseNo);

            const sndres = await apiService.getApiParamater('COMMON_BULK_RECEIPT', `?${sndparams.toString()}`);
            setUnitData(sndres?.data?.result?.data);

            const receivea = new URLSearchParams();
            receivea.append('Action', 'GetCreateLeaseInstallment');
            receivea.append('LeaseNo', selectedRow?.LeaseNo);

            const receiveres = await apiService.getApiParamater('COMMON_BULK_RECEIPT', `?${receivea.toString()}`);

            if (receiveres?.data?.result?.data?.length === 0) {
                toast.warning("No Receiveables Found");
                setUnitData(null);
                setDataList(null);
                setTotalAmount(0);
                setTotalVat(0);
                setTotalRent(0);
                return;
            } else {
                const updatedReceivables = Array.isArray(receiveres?.data?.result?.data)
                    ? receiveres.data.result.data.map(item => ({
                        ...item,
                        PaymentMethod: [{ label: 'PDC', value: 'PDC' }],
                        Amount: item.Total,
                        chequeDate: item.DueDate,
                    }))
                    : [{
                        ...receiveres.data.result.data,
                        PaymentMethod: [{ label: 'PDC', value: 'PDC' }],
                        Amount: receiveres.data.result.data.Total,
                        chequeDate: receiveres.data.result.data.DueDate,
                    }];

                setReceiveables(updatedReceivables);
            }

        } else {
            setTotalAmount(term?.Rent);
            setTotalVat(term?.VAT);
            setTotalRent(term?.Total);
            setDataList([res?.data?.result?.data]);

            const sndparams = new URLSearchParams();
            sndparams.append('Action', 'GetCreateLeaseTenantDetails');
            sndparams.append('LeaseNo', selectedRow?.LeaseNo);

            const sndres = await apiService.getApiParamater('COMMON_BULK_RECEIPT', `?${sndparams.toString()}`);
            setUnitData(sndres?.data?.result?.data);

            const receivea = new URLSearchParams();
            receivea.append('Action', 'GetCreateLeaseInstallment');
            receivea.append('LeaseNo', selectedRow?.LeaseNo);

            const receiveres = await apiService.getApiParamater('COMMON_BULK_RECEIPT', `?${receivea.toString()}`);

            if (receiveres?.data?.result?.data?.length === 0) {
                toast.warning("No Receiveables Found");
                setUnitData(null);
                setDataList(null);
                setTotalAmount(0);
                setTotalVat(0);
                setTotalRent(0);
                return;
            } else {
                const updatedReceivables = Array.isArray(receiveres?.data?.result?.data)
                    ? receiveres.data.result.data.map(item => ({
                        ...item,
                        PaymentMethod: [{ label: 'PDC', value: 'PDC' }],
                        Amount: item.Total,
                        chequeDate: item.DueDate,
                    }))
                    : [{
                        ...receiveres.data.result.data,
                        PaymentMethod: [{ label: 'PDC', value: 'PDC' }],
                        Amount: receiveres.data.result.data.Total,
                        chequeDate: receiveres.data.result.data.DueDate,
                    }];

                setReceiveables(updatedReceivables);
            }
        }
    };
    const handleChange = (field, value, formData) => {
        if (field === "Amount") {
            if (value > formData?.Balance) {
                toast.warning("Amount must be less then or Equal to Total")
                return
            } else {
                setFormData((prev) => ({ ...prev, [field]: value }));
            }
        } else {
            setFormData((prev) => ({ ...prev, [field]: value }));
        }
    }
    const paymentChange = (selectedOption) => {
        setFormData({ ...formData, PaymentMethod: selectedOption });
    }
    const drawnBankChange = (selectedOption) => {
        setFormData({ ...formData, drawnBank: selectedOption });
    }
    const debitAcountChange = (selectedOption) => {
        const selectedTanent = ModelDebitAccounts?.find(pro => pro?.value === selectedOption?.label)
        setFormData({
            ...formData,
            DabitAC: selectedOption,
            DabitAcName: { label: selectedTanent?.text || "", value: selectedTanent?.value || "" },
        });
    }
    const debitAcountNameChange = (selectedOption) => {
        const selectedTanent = ModelDebitAccounts?.find(pro => pro?.text === selectedOption?.label)
        setFormData({
            ...formData,
            DabitAcName: selectedOption,
            DabitAC: { label: selectedTanent?.value || "", value: selectedTanent?.text || "" },
        });
    }
    const taxChange = (selectedOption) => {
        if (!selectedOption) return;

        const selectedVat = selectedOption.value; // full VAT object
        const rate = selectedVat?.Rate || 0;

        // calculate VAT amount from IntAmount
        const vatAmount = ((formData?.IntAmount || 0) * rate) / 100;

        // update totals
        const newAmount = (formData?.IntAmount || 0) + vatAmount;

        setFormData({
            ...formData,
            TaxCode: selectedOption,
            VAT: vatAmount,                      // calculated VAT
            Amount: newAmount,                   // IntAmount + VAT
            Balance: newAmount - (formData?.AmountPaid || 0), // adjust with paid if any
            TaxRate: rate,
            TaxDescription: selectedVat?.Description
        });
    }
    const handleUpdate = () => {
        const updated = [...receiveables];
        const enteredAmount = Number(formData.Amount) || 0;
        const paymentMethod = formData.PaymentMethod[0]?.label || formData.PaymentMethod?.label;

        // ✅ Validation: ChequeNo required for PDC / Cheque
        if (enteredAmount > 0) {
            if ((paymentMethod === "PDC" || paymentMethod === "Cheque") && !formData?.ChequeNo) {
                toast.warning("Please enter Cheque No");
                return;
            }
        }

        // ✅ Always calculate from InitialBalance
        const initialBalance = updated[editIndex].InitialBalance ?? updated[editIndex].Balance ?? 0;
        // const newBalance = enteredAmount > 0 ? initialBalance - enteredAmount : initialBalance;

        // ✅ Update only the selected record with Amount + Balance
        updated[editIndex] = {
            ...updated[editIndex],
            ...formData,
            PaymentMethod: formData.PaymentMethod[0] || formData.PaymentMethod,
            Amount: enteredAmount >= 0 ? enteredAmount : updated[editIndex].Amount,
            // Balance: newBalance < 0 ? 0 : newBalance,
            Balance: initialBalance,
            chequeDate: updated[editIndex].DueDate || formData?.chequeDate,
            InitialBalance: initialBalance,
            ChequeNo: formData.ChequeNo,
        };

        // ✅ If PDC / Cheque, also copy details to subsequent rows
        if (paymentMethod === "PDC" || paymentMethod === "Cheque") {
            for (let i = editIndex + 1; i < updated.length; i++) {
                updated[i] = {
                    ...updated[i],
                    PaymentMethod: formData.PaymentMethod[0] || formData.PaymentMethod,
                    drawnBank: formData.drawnBank,
                    DabitAC: formData.DabitAC,
                    DabitAcName: formData.DabitAcName,
                    Narration: formData.Narration,
                    chequeDate: updated[i].DueDate || formData?.chequeDate,
                    ChequeNo:
                        formData.ChequeNo && !isNaN(formData.ChequeNo)
                            ? String(Number(formData.ChequeNo) + (i - editIndex))
                            : updated[i].ChequeNo,
                    // ⚡ Keep their own Amount & Balance (don’t touch)
                    Amount: updated[i].Amount,
                    Balance: updated[i].Balance,
                    InitialBalance: updated[i].InitialBalance ?? updated[i].Balance,
                };
            }
        }
        if (paymentMethod === "PDC" || paymentMethod === "Cheque") {
            if (enteredAmount > 0) {
                if (!formData.drawnBank) {
                    toast.warning("Please Select Drawn Bank")
                    return
                } else if (!formData.DabitAC) {
                    toast.warning("Please Select Debit Account")
                    return
                } else {
                    setReceiveables(updated);
                    handleClose();
                }
            } else {
                setReceiveables(updated);
                handleClose();
            }
        } else {
            setReceiveables(updated);
            handleClose();
        }
    }
    const handleSave = async () => {
        try {
            if (!dataList[0]?.LeaseNo) {
                toast.warning("No Unit are in this Lease")
                setloader(false);
                return
            }
            setloader(true);
            for (const item of receiveables) {
                const paymentLabel = item?.PaymentMethod?.[0]?.label || item?.PaymentMethod?.label;
                if (!paymentLabel) {
                    toast.warning(`Please Add Payment Method in Receiveables`);
                    setloader(false);
                    return;
                } else if (paymentLabel === "PDC" || paymentLabel === "Cheque") {
                    if (item?.Amount > 0) {
                        if (!item.ChequeNo) {
                            toast.warning(`Please Add Cheque No in Receiveables`);
                            setloader(false);
                            return;
                        } else if (!item.chequeDate) {
                            toast.warning(`Please Add Cheque Date in Receiveables`);
                            setloader(false);
                            return;
                        } else if (!item.drawnBank?.label) {
                            toast.warning(`Please Add Drawn Bank in Receiveables`);
                            setloader(false);
                            return;
                        } else if (!item.DabitAcName?.value) {
                            toast.warning(`Please Add Debit Account in Receiveables`);
                            setloader(false);
                            return;
                        }
                    }
                }
            }
            const selectedReceiveable = receiveables?.filter(pro => pro?.Amount > 0)
            if (selectedReceiveable?.length === 0) {
                toast.warning("Please Enter Amount in Receiveables")
                setloader(false);
                return
            }
            const currentDatetimeUTC = new Date().toISOString();
            const leaseReceipt = {
                record_Id: 0,
                tenantNo: unitData?.CustomerNo,
                tenantName: unitData?.CustomerName,
                groupId: selectedTrans?.GroupId,
                leaseNo: selectedTrans?.LeaseNo,
                property_No: selectedTrans?.PropertyNo,
                property_Name: selectedTrans?.Property_Name,
                unit_No: selectedTrans?.Unit_No,
                psdId: 0,
                installment_Desc: "0",
                paymentMethod: "0",
                receiptType: receiptData?.receiptType[0]?.label || receiptData?.receiptType?.label,
                paymentDate: receiptDate || currentDatetimeUTC,
                receiptNo: "0",
                chequeNo: '0',
                drawnOnBank: "0",
                chequeDate: "2025-09-04T05:03:18.455Z",
                ccType: "0",
                ccNo: "0",
                ccExpiryDate: "2025-09-04T05:03:18.455Z",
                installmentAmount: 0,
                taxCode: 0,
                vat: 0,
                total: 0,
                actualAmountToBePaid: 0,
                actualAmountPaid: 0,
                remainingAmount: "0",
                accountCode: "0",
                bankName: "0",
                bankAccount: "0",
                voucherNo: "0",
                isTax: false,
                isDeposit: false,
                isAdditionalAmount: false,
                isOtherReceipt: false,
                isChequeCleared: false,
                clearedDate: "2025-09-04T05:03:18.455Z",
                clearedBy: unitData?.CustomerNo,
                exp1: receiptData?.refNo || "0",
                exp2: "0",
                exp3: receiptData?.payee || "0",
                exp4: receiptData?.narration || "0",
                exp5: "0",
                modifiedBy: "0",
                modifiedOn: "2025-09-04T05:03:18.455Z",
                createdBy: "0",
                createdOn: "2025-09-04T05:03:18.455Z"
            };

            const lbGetUnitList = dataList.map((item, index) => ({
                leaseNo: item?.LeaseNo,
                property_Name: item?.Property_Name,
                unit_No: item?.Unit_No,
                taxDesctiption: item?.TaxDesctiption,
                rent: item?.Rent,
                vat: item?.VAT,
                total: item?.Total,
                paymentTermNoOfChqs: item?.PaymentTermNoOfChqs
            }));

            const getAdditionalChargesList = selectedReceiveable?.map((item, index) => ({
                description: item?.Description,
                dueDate: item?.DueDate,
                intAmount: item?.IntAmount,
                taxDescription: item?.TaxDescription,
                vat: item?.VAT,
                total: item?.Total,
                amountPaid: item?.AmountPaid,
                balance: item?.Balance,
                amount: item?.Amount || item?.Total,
                paymentMethod: item?.PaymentMethod?.label,
                chequeNo: item?.ChequeNo || "0",
                chequeDate: item?.chequeDate,
                drawnBank: item?.drawnBank?.label,
                debitAcCode: item?.DabitAcName?.value,
                debitAcName: item?.DabitAcName?.label,
                narration: item?.Narration,
                installmentYear: item?.InstallmentYear,
                invoiceNo: item?.InvoiceNo,
                invoiceDate: item?.InvoiceDate,
                isSD: item?.IsSD,
                isOther: item?.IsOther,
                taxCode: item?.TaxCode?.value?.RecordId || item?.TaxCode,
                taxRate: item?.TaxRate,
                psdId: item?.PSDId
            }));
            const body = {
                leasebulkreceiptMain: {
                    leaseReceipt: leaseReceipt,
                    getAdditionalChargesList: getAdditionalChargesList,
                    lbGetUnitList: lbGetUnitList,
                    lbSearchCustomerList: [
                        {
                            groupId: 0,
                            leaseNo: "0",
                            property_Name: "0",
                            unit_No: "0",
                            rent: 0,
                            tenantNo: "0",
                            tenantName: "0",
                            contactNo: "0",
                            customerNo: "0",
                            isChecked: true
                        }
                    ],
                    leaseReceiptLine: {
                        id: 0,
                        receiptNo: "0",
                        recordId: 0,
                        psdId: 0,
                        groupId: 0,
                        leaseNo: "0",
                        category: "0",
                        description: "0",
                        dueDate: "2025-09-04T05:03:18.455Z",
                        invoiceNo: "0",
                        invoiceDate: "2025-09-04T05:03:18.455Z",
                        installmentAmount: 0,
                        tax: "0",
                        taxCode: 0,
                        taxInclusive: true,
                        vatPercent: 0,
                        vat: 0,
                        total: 0,
                        amountPaid: 0,
                        balance: 0,
                        refNo: "0",
                        narration: "0",
                        costCenter1: "0",
                        costCenter2: "0",
                        crAcCode: "0",
                        crAcName: "0",
                        drAcCode: "0",
                        drAcName: "0",
                        isSD: true,
                        isOther: true,
                        debitId: "0",
                        paymentMethod: "0",
                        chequeNo: "0",
                        chequeDate: "2025-09-04T05:03:18.455Z",
                        drawnBank: "0",
                        amount: 0,
                        modifiedBy: "0",
                        modifiedOn: "2025-09-04T05:03:18.455Z",
                        createdBy: "0",
                        createdOn: "2025-09-04T05:03:18.455Z"
                    },
                    postingSeries: {
                        recordId: 0,
                        financialYear: "0",
                        postingId: 0,
                        voucherNo: "0",
                        voucherSeriesNo: 0,
                        postingType: "0",
                        voucherType: "0",
                        isDeleted: true,
                        isReversed: true,
                        transactionDate: "2025-09-04T05:03:18.455Z",
                        isApproved1: true,
                        approvedBy1: "0",
                        approvedDate1: "2025-09-04T05:03:18.455Z",
                        isApproved2: true,
                        approvedBy2: "0",
                        approvedDate2: "2025-09-04T05:03:18.455Z",
                        isApproved3: true,
                        approvedBy3: "0",
                        approvedDate3: "2025-09-04T05:03:18.455Z",
                        createdBy: "0",
                        createdOn: "2025-09-04T05:03:18.455Z"
                    },
                    tenantNo: "0",
                    tenantName: "0",
                    contactNo: "0",
                    emailID: "0",
                    vatRegNo: "0",
                    nationality: "0",
                    address: "0",
                    country: "0",
                    city: "0",
                    installments: 0,
                    voucherNo: "0"
                }
            }
            
            const postRes = await apiService.post("CREATE_BULK_RECEIPT", body);
            if (postRes?.data?.statusCode === 201) {
                toast.success(`Lease Bulk Receipt Created successfully`);
                setloader(false);
                handlePrint(postRes?.data?.result)
                handleClearFilters()
                navigate("/Property/Management/Lease/Bulk/Receipt/Listing")
            } else {
                setloader(false);
            }
        } catch (error) {
            setloader(false);

            console.error("Error Save Data", error);
        }
    }
    const handlePrint = (rowData) => {
        if (rowData) {
            const token = localStorage.getItem("Token");
            const DB = localStorage.getItem("DataBase")
            if (!token) {
                alert("Auth token is missing! Unable to proceed.");
                return;
            }
            const popupWidth = 1000;
            const popupHeight = 600;
            const popupLeft = (window.screen.width - popupWidth) / 2;
            const popupTop = (window.screen.height - popupHeight) / 2;
            const popup = window.open(
                "",
                "ReportPopup",
                `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`
            );

            if (popup) {
                const form = document.createElement("form");
                form.method = "POST";
                form.action = REACT_APP_REPORTS;
                form.target = "ReportPopup";

                const inputs = [
                    { name: "authToken", value: token },
                    { name: "_db", value: DB },
                    { name: "RecordId", value: "" },
                    { name: "LeaseNo", value: rowData?.leaseNo },
                    { name: "ReceiptNo", value: rowData?.receiptNo },
                    { name: "reportName", value: 'LEASEBULKRPT' },
                ];
                inputs.forEach(({ name, value }) => {
                    const input = document.createElement("input");
                    input.type = "hidden";
                    input.name = name;
                    input.value = value;
                    form.appendChild(input);
                });

                document.body.appendChild(form);
                form.submit();
                document.body.removeChild(form);
            }
        }
    }
    const handleReceiptType = (selectedOption) => {
        setReceiptData({ ...receiptData, receiptType: selectedOption });
    }
    const formatDate = (date) => {
        if (!date) return null;
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0'); // month is 0-based
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
    const handleReceiptDate = ({ name, value }) => {
        const formattedDate = formatDate(value);
        setReceiptDate(formattedDate);
    }
    const handleReceiptChange = (field, value) => {
        setReceiptData((prev) => ({ ...prev, [field]: value }));
    }

    return (
        <div className='p-3'>
            <div className="d-flex mb-3">
                <div className="col-lg-8 nav nav-pills overslid d-flex gap-4">
                    <div className={`dashitems sidebar-text center ${activeTab === 0 ? "sideActive" : ""}`} onClick={() => handleTabClick(0)}>
                        Search Tenant
                    </div>
                    <div className={`dashitems sidebar-text center  ${activeTab === 1 ? "sideActive" : ""}`} onClick={() => handleTabClick(1)}>
                        Unit Details
                    </div>
                    <div className={`dashitems sidebar-text center  ${activeTab === 2 ? "sideActive" : ""}`} onClick={() => handleTabClick(2)}>
                        Receipt Details
                    </div>
                </div>
                <div className="col-lg-4 d-flex gap-1">
                    {loading === true ? (
                        <div className="mainbtn flex-end gap-2 w-50">
                            <ClipLoader color="#ffffff" className="mt-1" size={25} />
                        </div>
                    ) : (
                        <div className="mainbtn flex-end gap-2 w-50" onClick={handleSave}>
                            <FaSave color="#fff" className="center mt-2 mx-2" />
                            <div className="center">Save</div>
                        </div>
                    )}
                    <div className="mainbtnRed flex-end gap-2 w-50" >
                        <RiRefreshLine color="#fff" className="center mt-2 mx-2" />
                        <div className="center">Reset</div>
                    </div>
                    <div className="mainbtnSecondary flex-end gap-2 w-50" onClick={handleBackClick}>
                        <FaChevronLeft color="#fff" className="center mt-2 mx-2" />
                        <div className="center">Back</div>
                    </div>
                </div>
            </div>
            {gridVisibility[0] && (
                <div className=''>
                    <div className="cost-center-section mt-3">
                        <div className="d-flex cursor-pointer slide-header"
                            onClick={() => setFilterTab(!FilterTab)}>
                            <div className='h6 pt-1'>Transaction Details</div>
                        </div>
                        <div className={`slide-content ${FilterTab ? 'open' : 'closed'}`}>
                            <div className={`border-box2 p-3 ${FilterTab ? 'slide-in' : 'slide-out'}`}>
                                <div className="form-group grid-contain ">
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label pt-1 start"> Property</label>
                                        <Select
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 5,
                                                padding: 9
                                            })}
                                            menuPortalTarget={document.body}
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                    color: state.isFocused ? '#000 ' : '#000',
                                                    ':hover': {
                                                        backgroundColor: '#F5F5F5',
                                                        color: '#000 ',
                                                    },
                                                }),
                                            }}
                                            className="w-75 p-0"
                                            value={transData.Proprty}
                                            options={proprtyList?.map((cost) => ({ value: cost?.value, label: cost?.text }))}
                                            onChange={(selectedOption) => handlePropertyChange(selectedOption)}
                                        />
                                    </div>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label pt-1 start"> Unit No</label>
                                        <Select
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 5,
                                                padding: 9
                                            })}
                                            menuPortalTarget={document.body}
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                    color: state.isFocused ? '#000 ' : '#000',
                                                    ':hover': {
                                                        backgroundColor: '#F5F5F5',
                                                        color: '#000 ',
                                                    },
                                                }),
                                            }}
                                            className="w-75 p-0"
                                            value={transData.unitNo}
                                            options={unitList?.map((cost) => ({ value: cost?.text, label: cost?.value }))}
                                            onChange={(selectedOption) => handleUitNo(selectedOption)}
                                        />
                                    </div>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label pt-1 start"> Tenant No</label>
                                        <Select
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 5,
                                                padding: 9
                                            })}
                                            menuPortalTarget={document.body}
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                    color: state.isFocused ? '#000 ' : '#000',
                                                    ':hover': {
                                                        backgroundColor: '#F5F5F5',
                                                        color: '#000 ',
                                                    },
                                                }),
                                            }}
                                            className="w-75 p-0"
                                            value={transData.TenantNo}
                                            options={tenantList?.map((cost) => ({ value: cost?.text, label: cost?.value }))}
                                            onChange={(selectedOption) => handleTenantNo(selectedOption)}
                                        />
                                    </div>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label pt-1 start"> Tenant</label>
                                        <Select
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 5,
                                                padding: 9
                                            })}
                                            menuPortalTarget={document.body}
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                    color: state.isFocused ? '#000 ' : '#000',
                                                    ':hover': {
                                                        backgroundColor: '#F5F5F5',
                                                        color: '#000 ',
                                                    },
                                                }),
                                            }}
                                            className="w-75 p-0"
                                            value={transData.Tenant}
                                            options={tenantList?.map((cost) => ({ value: cost?.value, label: cost?.text }))}
                                            onChange={(selectedOption) => handleTenant(selectedOption)}
                                        />
                                    </div>
                                    <div className='d-flex gap-1'>
                                        <div className="mainbtnGry flex-end gap-2 w-50" onClick={handleTransSearch}>
                                            <IoSearchOutline color="#fff" className="center mt-1 mx-2" />
                                            <div className="center">Search</div>
                                        </div>
                                        <div className="mainbtnRed flex-end gap-2 w-50" onClick={handleClearFilters} >
                                            <RiRefreshLine color="#fff" className="center mt-1 mx-2" />
                                            <div className="center">Reset</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='gridshad mt-1'>
                        <div className='table-container' style={{ overflowX: 'auto', height: '550px' }}>
                            <table className='table table-bordered gridshad'>
                                <thead className='dynoTable'>
                                    <tr>
                                        <th style={{ width: 50 }}></th>
                                        <th>Lease No</th>
                                        <th>Property</th>
                                        <th>Unit No</th>
                                        <th>Rent</th>
                                        <th>Tenant No</th>
                                        <th>Tenant</th>
                                        <th>Contact No</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(transList) && transList.map((data, index) => (
                                        <tr
                                            key={index}
                                            style={{
                                                background: index % 2 === 0 ? '#F0EDF5' : '#fff',
                                                cursor: 'pointer',
                                            }}
                                            onClick={() => onRowSelect(data, index)}
                                        >
                                            <td className='text-center'>
                                                <div className='center mt-2'>
                                                    <input
                                                        type="checkbox"
                                                        style={{ height: "20px", width: "20px" }}
                                                        checked={selectedIndex === index}
                                                        onChange={() => onRowSelect(data, index)}
                                                    />
                                                </div>
                                            </td>
                                            <td><input value={data?.LeaseNo} className='p-1 w-100' disabled /></td>
                                            <td><input value={data?.Property_Name} className='p-1 w-100' disabled /></td>
                                            <td><input value={data?.Unit_No} className='p-1 w-100' disabled /></td>
                                            <td><input value={data?.Rent} className='p-1 w-100' disabled /></td>
                                            <td><input value={data?.TenantNo} className='p-1 w-100' disabled /></td>
                                            <td><input value={data?.TenantName} className='p-1 w-100' disabled /></td>
                                            <td><input value={data?.ContactNo} className='p-1 w-100' disabled /></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            )}
            {gridVisibility[1] && (
                <div className=''>
                    <div className="cost-center-section mt-3">
                        <div className="d-flex cursor-pointer slide-header"
                            onClick={() => setFilterTab(!FilterTab)}>
                            <div className='h6 pt-1'>Tenant Details</div>
                        </div>
                        <div className={`slide-content ${FilterTab ? 'open' : 'closed'}`}>
                            <div className={`border-box2 p-3 ${FilterTab ? 'slide-in' : 'slide-out'}`}>
                                <div className="form-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(360px, 1fr))', gap: '20px' }}>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label center start">Tenant No</label>
                                        <input className="p-2 form-control w-75" disabled value={unitData?.CustomerNo} />
                                    </div>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label center start">Tenant</label>
                                        <input className="p-2 form-control w-75" disabled value={unitData?.CustomerName} />
                                    </div>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label center start">Contact No</label>
                                        <input className="p-2 form-control w-75" disabled value={unitData?.ContactNo} />
                                    </div>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label center start">Email ID</label>
                                        <input className="p-2 form-control w-75" disabled value={unitData?.EmailID} />
                                    </div>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label center start">VAT Reg No</label>
                                        <input className="p-2 form-control w-75" disabled value={unitData?.VATRegNo} />
                                    </div>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label center start">Nationality</label>
                                        <input className="p-2 form-control w-75" disabled value={unitData?.Nationality} />
                                    </div>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label center start">Address</label>
                                        <input className="p-2 form-control w-75" disabled value={unitData?.Address} />
                                    </div>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label center start">Country</label>
                                        <input className="p-2 form-control w-75" disabled value={unitData?.Country} />
                                    </div>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label center start">City</label>
                                        <input className="p-2 form-control w-75" disabled value={unitData?.City} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="cost-center-section mt-3">
                        <div className="d-flex cursor-pointer slide-header"
                            onClick={() => setPaymentTab(!PaymentTab)}>
                            <div className='mainInvHead pt-1'>Units</div>
                        </div>
                        <div className={`slide-content ${PaymentTab ? 'open' : 'closed'}`}>
                            <div className={`border-box2 ${PaymentTab ? 'slide-in' : 'slide-out'}`}>
                                <div className='table-container' style={{ overflowX: 'auto', height: "auto" }}>
                                    <table className='table table-bordered'>
                                        <thead className='dynoTable'>
                                            <tr>
                                                <th>Lease No</th>
                                                <th>Property</th>
                                                <th>Unit No</th>
                                                <th>Tax</th>
                                                <th>Rent</th>
                                                <th>VAT</th>
                                                <th>Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Array.isArray(dataList) && dataList?.map((data, index) => (
                                                <tr>
                                                    <td className='m-0 p-0'><input value={data?.LeaseNo} className='p-1' disabled style={{ width: "100%" }} /></td>
                                                    <td className='m-0 p-0'><input value={data?.Property_Name} className='p-1' disabled style={{ width: "100%" }} /></td>
                                                    <td className='m-0 p-0'><input value={data?.Unit_No} className='p-1' disabled style={{ width: "100%" }} /></td>
                                                    <td className='m-0 p-0'><input value={data?.TaxDesctiption} className='p-1' disabled style={{ width: "100%" }} /></td>
                                                    <td className='m-0 p-0'><input value={data?.Rent?.toFixed(currencyPrecision?.decimalNumbers)} className='p-1' disabled style={{ width: "100%" }} /></td>
                                                    <td className='m-0 p-0'><input value={data?.VAT?.toFixed(currencyPrecision?.decimalNumbers)} className='p-1' disabled style={{ width: "100%" }} /></td>
                                                    <td className='m-0 p-0'><input value={data?.Total?.toFixed(currencyPrecision?.decimalNumbers)} className='p-1' disabled style={{ width: "100%" }} /></td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <div className='d-flex justify-content-between boxs'>
                                    <div className='d-flex gap-2'>
                                        <div className="totalhead center">Total Rent </div>
                                        <div className='field'>{totalRent?.toFixed(currencyPrecision?.decimalNumbers) || "---"}</div>
                                    </div>
                                    <div className='d-flex gap-2'>
                                        <div className="totalhead center">Total Vat</div>
                                        <div className='field'>{totalVat?.toFixed(currencyPrecision?.decimalNumbers) || "---"}</div>
                                    </div>
                                    <div className='d-flex gap-2'>
                                        <div className="totalhead center">Total Amount</div>
                                        <div className='field'>{totalAmount?.toFixed(currencyPrecision?.decimalNumbers) || "---"}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {gridVisibility[2] && (
                <div className=''>
                    <div className="cost-center-section mt-3">
                        <div className="d-flex cursor-pointer slide-header"
                            onClick={() => setFilterTab(!FilterTab)}>
                            <div className='h6 pt-1'>Receipt Details</div>
                        </div>
                        <div className={`slide-content ${FilterTab ? 'open' : 'closed'}`}>
                            <div className={`border-box2 p-3 ${FilterTab ? 'slide-in' : 'slide-out'}`}>
                                <div className="form-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(360px, 1fr))', gap: '20px' }}>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label center start">Receipt Type</label>
                                        <Select
                                            className="p-0 w-100"
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 5,
                                                padding: 9
                                            })}
                                            menuPortalTarget={document.body}
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                    color: state.isFocused ? '#000 ' : '#000',
                                                    ':hover': {
                                                        backgroundColor: '#F5F5F5',
                                                        color: '#000 ',
                                                    },
                                                }),
                                            }}
                                            value={receiptData.receiptType}
                                            options={receptType}
                                            onChange={handleReceiptType}
                                        />
                                    </div>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label center start">Receipt Date</label>
                                        <DatePicker
                                            todayButton="Today"
                                            selected={receiptDate}
                                            onChange={(date) => handleReceiptDate({ name: 'receiptDate', value: date })}
                                            dateFormat="dd-MMM-yyyy"
                                            className="p-2 form-control w-100"
                                        />
                                    </div>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label center start">Installments</label>
                                        <input type="number" className="p-2 form-control w-75" name='installment'
                                            onChange={(e) => handleReceiptChange("installment", e.target.value)}
                                            disabled value={receiptData.installment} />
                                    </div>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label center start">Ref No</label>
                                        <input type="text" className="p-2 form-control w-75" name='refNo'
                                            onChange={(e) => handleReceiptChange("refNo", e.target.value)}
                                            value={receiptData.refNo} />
                                    </div>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label center start">Payee</label>
                                        <input type="text" className="p-2 form-control w-75" name='payee'
                                            onChange={(e) => handleReceiptChange("payee", e.target.value)}
                                            value={receiptData.payee} />
                                    </div>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label center start">Common Narration</label>
                                        <input type="text" className="p-2 form-control w-75" name='narration'
                                            onChange={(e) => handleReceiptChange("narration", e.target.value)}
                                            value={receiptData.narration} />
                                    </div>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label center start">Description</label>
                                        <textarea type="text" className="p-2 form-control w-75" name='description'
                                            onChange={(e) => handleReceiptChange("description", e.target.value)}
                                            maxLength={950} placeholder='Max 950 Characters Only'
                                            value={receiptData.description} />
                                    </div>
                                    {/* <div className=' mt-3'>
                                        <div className="mainbtn flex-end gap-2 w-50">
                                            <IoSearchOutline color="#fff" className="center mt-1 mx-2" />
                                            <div className="center">Yearly Basis</div>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="cost-center-section mt-3">
                        <div className="d-flex cursor-pointer slide-header"
                            onClick={() => setPaymentTab(!PaymentTab)}>
                            <div className='mainInvHead pt-1'>Additional Charges Details</div>
                        </div>
                        <div className={`slide-content ${PaymentTab ? 'open' : 'closed'}`}>
                            <div className={`border-box2 ${PaymentTab ? 'slide-in' : 'slide-out'}`}>
                                <div className='table-container' style={{ overflowX: 'auto', height: "600px" }}>
                                    <table className='table table-bordered gridshad'>
                                        <thead className='dynoTable'>
                                            <tr>
                                                <th>Action</th>
                                                <th>Description</th>
                                                <th>Due Date</th>
                                                <th>Int Amount</th>
                                                <th>Tax Code</th>
                                                <th>VAT</th>
                                                <th>Total</th>
                                                <th>Amount Paid</th>
                                                <th>Balance</th>
                                                <th>Amount</th>
                                                <th>Payment Menthod</th>
                                                <th>Cheque No</th>
                                                <th>Cheque Date</th>
                                                <th>Drawn Bank</th>
                                                <th>Debit Ac Code </th>
                                                <th>Debit Ac Name</th>
                                                <th>Narration</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Array.isArray(receiveables) && receiveables?.map((data, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        <FaEdit
                                                            size={22}
                                                            style={{ cursor: "pointer" }}
                                                            onClick={() => handleShow(index)}
                                                        />
                                                    </td>
                                                    <td className='m-0 p-0'><input value={data?.Description} className='p-1' disabled style={{ width: "auto" }} /></td>
                                                    <td className='m-0 p-0'><input value={moment(data?.DueDate).format('DD-MMM-yyyy')} className='p-1' disabled style={{ width: "auto" }} /></td>
                                                    <td className='m-0 p-0'><input value={data?.IntAmount?.toFixed(currencyPrecision?.decimalNumbers)} className='p-1' disabled style={{ width: "auto" }} /></td>
                                                    <td className='m-0 p-0'><input value={data?.TaxCode?.label ? data?.TaxCode?.label : data?.TaxDescription} className='p-1' disabled style={{ width: "auto" }} /></td>
                                                    <td className='m-0 p-0'><input value={data?.VAT?.toFixed(currencyPrecision?.decimalNumbers)} className='p-1' disabled style={{ width: "auto" }} /></td>
                                                    <td className='m-0 p-0'><input value={data?.Total?.toFixed(currencyPrecision?.decimalNumbers)} className='p-1' disabled style={{ width: "auto" }} /></td>
                                                    <td className='m-0 p-0'><input value={data?.AmountPaid?.toFixed(currencyPrecision?.decimalNumbers)} className='p-1' disabled style={{ width: "auto" }} /></td>
                                                    <td className='m-0 p-0'><input value={data?.Balance?.toFixed(currencyPrecision?.decimalNumbers)} className='p-1' disabled style={{ width: "auto" }} /></td>
                                                    <td className='m-0 p-0'><input value={data?.Amount} className='p-1' disabled style={{ width: "auto" }} /></td>
                                                    <td className='m-0 p-0'><input value={data?.PaymentMethod?.label || "PDC"} className='p-1' disabled style={{ width: "auto" }} /></td>
                                                    <td className='m-0 p-0'><input value={data?.ChequeNo} className='p-1' disabled style={{ width: "auto" }} /></td>
                                                    <td className='m-0 p-0'><input value={moment(data?.chequeDate || data?.DueDate).format('DD-MMM-yyyy')} className='p-1' disabled style={{ width: "auto" }} /></td>
                                                    <td className='m-0 p-0'><input value={data?.drawnBank?.label} className='p-1' disabled style={{ width: "auto" }} /></td>
                                                    <td className='m-0 p-0'><input value={data?.DabitAC?.label} className='p-1' disabled style={{ width: "auto" }} /></td>
                                                    <td className='m-0 p-0'><input value={data?.DabitAcName?.label} className='p-1' disabled style={{ width: "auto" }} /></td>
                                                    <td className='m-0 p-0'><input value={data?.Narration} className='p-1' disabled style={{ width: "auto" }} /></td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="d-flex justify-content-between boxs">
                                    <div className="d-flex gap-2">
                                        <div className="totalhead center">Total Int Amount</div>
                                        <div className="field">{recIntAmount?.toFixed(currencyPrecision?.decimalNumbers) || "---"}</div>
                                    </div>
                                    <div className="d-flex gap-2">
                                        <div className="totalhead center">Total VAT</div>
                                        <div className="field">{`${receVAT?.toFixed(currencyPrecision?.decimalNumbers)}` || "---"}</div>
                                    </div>
                                    <div className="d-flex gap-2">
                                        <div className="totalhead center">Total Paid Amount</div>
                                        <div className="field">{recPaidAmount?.toFixed(currencyPrecision?.decimalNumbers) || "---"}</div>
                                    </div>
                                    <div className="d-flex gap-2">
                                        <div className="totalhead center">Total </div>
                                        <div className="field">{recTotal?.toFixed(currencyPrecision?.decimalNumbers) || "---"}</div>
                                    </div>
                                    <div className="d-flex gap-2">
                                        <div className="totalhead center">Total Balance</div>
                                        <div className="field">{recBalance?.toFixed(currencyPrecision?.decimalNumbers) || "---"}</div>
                                    </div>
                                    <div className="d-flex gap-2">
                                        <div className="totalhead center">Total Amount</div>
                                        <div className="field">{recAmount?.toFixed(currencyPrecision?.decimalNumbers) || "---"}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <div>
                <Modal
                    show={show}
                    onHide={handleClose}
                    size="lg"
                // onShow={() => loadFormData(editIndex)}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Payment & Bank Details</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <div
                                className="form-group"
                                style={{
                                    display: "grid",
                                    gridTemplateColumns: "repeat(auto-fill, minmax(360px, 1fr))",
                                    gap: "20px",
                                }}
                            >
                                {/* Due Date */}
                                <div className="d-flex">
                                    <label className="form-label center start">Due Date</label>
                                    <input
                                        type="date"
                                        className="p-2 form-control w-75"
                                        value={formData.DueDate ? formData.DueDate.split("T")[0] : ""}
                                        onChange={(e) => handleChange("DueDate", e.target.value)}
                                    />
                                </div>

                                {/* Int Amount */}
                                <div className="d-flex">
                                    <label className="form-label center start">Int Amount</label>
                                    <input
                                        type="number"
                                        className="p-2 form-control w-75"
                                        value={formData.IntAmount} readOnly
                                    />
                                </div>

                                {/* Tax Code */}
                                <div className="d-flex">
                                    <label className="form-label center start">Tax Code</label>
                                    <Select
                                        className="p-0 w-100"
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }}
                                        value={formData.VatCode}
                                        options={ModelTaxMaster?.map((cost) => ({ value: cost, label: cost?.Description }))}
                                        onChange={taxChange}
                                    />
                                </div>

                                {/* VAT */}
                                <div className="d-flex">
                                    <label className="form-label center start">VAT</label>
                                    <input
                                        type="number"
                                        className="p-2 form-control w-75"
                                        value={formData.VAT}
                                        disabled
                                    />
                                </div>

                                {/* Total */}
                                <div className="d-flex">
                                    <label className="form-label center start">Total</label>
                                    <input
                                        type="number"
                                        className="p-2 form-control w-75"
                                        value={formData.Total}
                                        disabled
                                    />
                                </div>

                                {/* Amount */}
                                <div className="d-flex">
                                    <label className="form-label center start">Amount</label>
                                    <input
                                        type="number"
                                        max={formData?.Balance}
                                        className="p-2 form-control w-75"
                                        value={formData.Amount}
                                        onChange={(e) => handleChange("Amount", e.target.value, formData)}
                                    />
                                </div>

                                {/* Payment Method */}
                                <div className="d-flex">
                                    <label className="form-label center start">Payment Method</label>
                                    <WindowedSelect
                                        className="w-75 p-0"
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}

                                        menuPortalTarget={document.body}
                                        menuPlacement="auto"
                                        menuShouldScrollIntoView={false}
                                        styles={{
                                            menuPortal: base => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5' : null,
                                                color: '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000',
                                                },
                                            }),
                                        }}
                                        value={formData.PaymentMethod}
                                        options={paymentMethod?.map((cost) => ({ value: cost?.value, label: cost?.text }))}
                                        onChange={paymentChange}
                                    />
                                </div>

                                {/* Cheque No */}
                                <div className="d-flex">
                                    <label className="form-label center start">Cheque No</label>
                                    <input
                                        type="text"
                                        className="p-2 form-control w-75"
                                        value={formData.ChequeNo} maxLength={20}
                                        onChange={(e) => handleChange("ChequeNo", e.target.value)}
                                    />
                                </div>

                                {/* Cheque Date */}
                                <div className="d-flex">
                                    <label className="form-label center start">Cheque Date</label>
                                    <input
                                        type="date"
                                        className="p-2 form-control w-75"
                                        value={formData.chequeDate ? formData.chequeDate.split("T")[0] : ""}
                                        onChange={(e) => handleChange("chequeDate", e.target.value)}
                                    />
                                </div>

                                {/* Drawn Bank */}
                                <div className="d-flex">
                                    <label className="form-label center start">Drawn Bank</label>
                                    <WindowedSelect
                                        className="w-75 p-0"
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}

                                        menuPortalTarget={document.body}
                                        menuPlacement="auto"
                                        menuShouldScrollIntoView={false}
                                        styles={{
                                            menuPortal: base => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5' : null,
                                                color: '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000',
                                                },
                                            }),
                                        }}
                                        value={formData.drawnBank}
                                        options={drawnBankList?.map((cost) => ({ value: cost?.value, label: cost?.text }))}
                                        onChange={drawnBankChange}
                                    />
                                </div>

                                {/* Debit Account Code */}
                                <div className="d-flex">
                                    <label className="form-label center start">Debit Account Code</label>
                                    <WindowedSelect
                                        className="w-75 p-0"
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}

                                        menuPortalTarget={document.body}
                                        menuPlacement="auto"
                                        menuShouldScrollIntoView={false}
                                        styles={{
                                            menuPortal: base => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5' : null,
                                                color: '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000',
                                                },
                                            }),
                                        }}
                                        value={formData.DabitAC}
                                        options={ModelDebitAccounts?.map((cost) => ({ value: cost?.text, label: cost?.value }))}
                                        onChange={debitAcountChange}
                                    />
                                </div>

                                {/* Account Name */}
                                <div className="d-flex">
                                    <label className="form-label center start">Account Name</label>
                                    <WindowedSelect
                                        className="w-75 p-0"
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}

                                        menuPortalTarget={document.body}
                                        menuPlacement="auto"
                                        menuShouldScrollIntoView={false}
                                        styles={{
                                            menuPortal: base => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5' : null,
                                                color: '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000',
                                                },
                                            }),
                                        }}
                                        value={formData.DabitAcName}
                                        options={ModelDebitAccounts?.map((cost) => ({ value: cost?.value, label: cost?.text }))}
                                        onChange={debitAcountNameChange}
                                    />
                                </div>

                                {/* Narration */}
                                <div className="d-flex">
                                    <label className="form-label center start">Narration</label>
                                    <textarea
                                        className="p-2 form-control w-75"
                                        value={formData.Narration}
                                        onChange={(e) => handleChange("Narration", e.target.value)}
                                    />
                                </div>
                            </div>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Close
                        </Button>
                        <Button variant="primary" onClick={handleUpdate}>
                            Update
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        </div>
    );
};
export default BulkReceipt;